import styled from "styled-components";
import RightArrow from "assets/icons/right-arrow.svg";

export const Row = styled.button`
    color: ${(props) => props.theme.colors.text.black};
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 20px;
    font-size: 14px;
    text-align: left;
    width: 100%;
    height: ${(props) => props.height || "30px"};
    border: none;
    background-color: transparent;
    cursor: ${(props) => props.cursor || "pointer"};

    &:disabled{
        cursor: default;
    }
`;

export const RowWithArrow = styled(Row)`
    position: relative;
    &:after {
        content: "";
        position: absolute;
        top: 50%;
        right: 10px;
        transform: translateY(-50%);
        width: 15px;
        height: 15px;
        background-image: url(${RightArrow});
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
    }
`;